import { Buffer } from 'buffer';

export default {
  fromBase64: (base64: string, filename = 'file', options?: FilePropertyBag) :File => new File([Buffer.from(base64, 'base64')], filename, options),
};
